export const LEGAL_URL = 'http://www.hipotecario.com.ar.';

/** Texto legal fijo con las fechas insertadas. El usuario solo edita las fechas. */
export const buildLegalText = (from: string, to: string): string =>
  `Válido desde el ${from} al ${to}. Publicidad. Cartera de Consumo.\nPara más información o limitaciones aplicables consulte en\n${LEGAL_URL}`;

/**
 * 'YYYY-MM-DD' (lo que emite el calendar) → 'DD/MM/YYYY'.
 * Ancho fijo (zero-padded) a propósito: mantiene la URL siempre en la misma
 * posición de caracteres, así el resaltado naranja no se corre.
 */
export const toLegalDate = (iso: string): string => {
  const [y, m, d] = iso.split('-');
  return y && m && d ? `${d}/${m}/${y}` : iso;
};
